var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container text-center mt-5"},[_c('first-heading',{attrs:{"title":_vm.title}}),_c('p',[_vm._v(_vm._s(_vm.message))]),_c('b-spinner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }